import React, { useEffect, useState } from "react"
import axios from '../../../../axios-instance';
import { getCustomURLs } from "../../../../helpers/getCustomURLs";
import { getHeaders } from "../../../../helpers/getHeaders";
import ls from 'localstorage-slim';
import { paymentProvidersOptions } from "../../../SeasonPass/constants";
import styles from './PaymentMethodsPage.module.sass';
import CheckBox from "../../../../components/UI/Checkbox/CheckBox";
import { toast } from "react-toastify";
import NewLoader from "../../../../components/NewLoader/NewLoader";

export const PaymentMethodsPage = () => {
    const [state, setStateInternal] = useState({
        paymentMethods: [],
        loading: true,
    });
    const setState = (changes) => setStateInternal(v => { return { ...v, ...changes } });

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get(`${getCustomURLs().API_URL}/PaymentMethod`, {
                    headers: getHeaders(ls.get('user').token),
                });

                setState({ paymentMethods: data, loading: false });
            } catch (error) {
                toast.error('Something went wrong');
                setState({ loading: false });
            }
        })();
    }, []);

    const changeMethodDefault = (v, id) => {
        const method = state.paymentMethods.find(m => m.id === id);

        if (method) {
            method.isPromoterDefault = !method.isPromoterDefault;
            setState({ paymentMethods: state.paymentMethods.map(m => m) });
        }
    }

    const changeMethodName = (v, id) => {
        const method = state.paymentMethods.find(m => m.id === id);

        if (method) {
            method.paymentMethodName = v;
            setState({ paymentMethods: state.paymentMethods.map(m => m) });
        }
    }

    const savePaymentMethods = async () => {
        setState({ loading: true });

        try {
            await axios.put(`${getCustomURLs().API_URL}/PaymentMethod`,
                state.paymentMethods,
                {
                    headers: getHeaders(ls.get('user').token),
                });

            toast.success('Payments is saved successfully');
        } catch (error) {
            toast.error('Payments is not saved');
        } finally {
            setState({ loading: false });
        }
    }

    if (state.loading) {
        return (
            <div className="wallets">
                <NewLoader />
            </div>
        );
    }

    return <>

        <section className={styles['payment-method-list']}>
            {state.paymentMethods.map(m => <div className={styles['payment-method-item']}>

                <strong>Payment provider: {paymentProvidersOptions.find(i => i.id === m.provider).label}</strong>

                <div className="add-event__block" style={{ marginBottom: 0 }}>
                    <label>Name</label>
                    <input
                        type="text"
                        name="name"
                        value={m.paymentMethodName}
                        placeholder="Enter name"
                        minLength="3"
                        maxLength="500"
                        onChange={e => changeMethodName(e.target.value, m.id)}
                    />
                </div>

                <div>
                    <CheckBox
                        name="change-default"
                        id={`change-default_${m.id}`}
                        checked={m.isPromoterDefault}
                        onChange={v => changeMethodDefault(v.target.checked, m.id)}>
                        Use as default
                    </CheckBox>


                </div>
            </div>)}
        </section>


        <div className={styles['footer']}>

            <button className={`btn-primary-new admin ${styles['button']}`}
                onClick={savePaymentMethods}>
                Save
            </button>

        </div>

    </>
}